module.exports = __webpack_public_path__ + "img/bgDrawer.b6d302ac.webp";